export default __webpack_public_path__ + "static/media/default_blog_banner.f296b547.svg";